<template>
  <div class="b-order-detail-wrap page-wrap">
    <div v-if="showLoading" class="loading-line">
      <p>
        <i class="el-icon-loading" />
      </p>
    </div>
    <OrderDetailCard
      v-show="!showLoading"
      :order-info="orderInfo"
      :type="userType"
      @cancleOrder="handleEvent('cancleOrder', $event)"
      @controversyOrder="handleEvent('controversyOrder', $event)"
      @completeOrder="handleEvent('completeOrder', $event)"
      @writeReview="handleEvent('writeReview', $event)"
      @refoundDetail="handleEvent('refoundDetail', $event)"
      @refoundOrder="handleEvent('refoundOrder', $event)"
      @acceptOrder="handleEvent('acceptOrder', $event)"
    />
    <ProgressStep
      class="progress-container"
      :steps="steps"
      :currentStatus="currentOrderStatus"
      valKey="afterOptionStatus"
    >
      <template v-slot="{ item, actived }">
        <div class="progress-step" :class="{ 'progress-defalut': !actived }">
          <div class="progress-title">
            {{ item.label }}
          </div>
           <div class="progress-content" v-if="item.updateTime&&(item.afterOptionStatus!=='Controversy'||currentOrderStatus!=='Controversy')">
              {{ new Date(item.updateTime).$format('yyyy-MM-dd hh:mm:ss') }}
            </div>
        </div>
      </template>
    </ProgressStep>
    <AmountEl>
      <orderCard
        class="card-hide"
        v-if="$route.name !== 'UserOrder'"
        ref="orderCardRef"
        :index="0"
        :type="userType"
        :orderInfo="orderInfo"
        @closeOrderDialog="$emit('closeOrderDialog')"
        @hasAccept="changeOrderInfo"
      ></orderCard>
    </AmountEl>
  </div>
</template>

<script>
import orderCard from '@/components/Order/order-card.vue';
import OrderDetailCard from './order-detail-card';
import ProgressStep from '@/components/common/progress-step';
import { orderDetail } from './order';
import AmountEl from '@/components/common/amount';

export default {
  components: {
    OrderDetailCard,
    ProgressStep,
    orderCard,
    AmountEl,
  },
  props: {
    orderNo: String,
    userType: String,
    detailVisiable: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    orderNo() {
      this.getOrderDetail();
    },
    detailVisiable(value) {
      if (value) this.getOrderDetail();
    },
  },
  data() {
    return {
      showLoading: true,
      skillId: -1,
      skillObj: {},
      pageLoaded: false,
      allowPopupClose: false,
      commentsPopSkillObj: {
        count: null,
        pageContent: [],
      },
      isRefresh: false,
      isSelf: true,
      commentsPageSize: 5,
      orderInfo: {
        orderItemVoList: [{}],
      },
      countDownText: '',
      steps: [],
      timer: null,
      playerUserUuid: '',
      stepsLabel: {
        Effective: '下單',
        Processing: '陪玩師接單',
        PlayerConfirm: '陪玩師確認完成',
        REFUND_SUCCESS: '陪玩師退款',
        Completed: '已完成',
        Finished: '評價',
        Invalid: '訂單取消',
        REFUND_FULL: '全部退款',
        REFUND_PART: '部分退款',
        Controversy: '申請退款',
        Negotiate: '陪玩師拒絕退款',
        alreadyBack: '退款成功'
      }
    };
  },
  computed: {
    currentOrderStatus() {
      if (!this.orderInfo) return '';
      if (this.orderInfo.status === 'REFUND_SUCCESS') {
        return this.orderInfo.refundType === 'FULL'
          ? 'REFUND_FULL'
          : 'REFUND_PART';
      }
      if (this.orderInfo.status === 'Invalid') {
        return this.orderInfo.refundType === 'FULL'
          ? 'alreadyBack'
          : 'Invalid';
      }
      return this.orderInfo.status;
    },
    orderStatusInfo() {
      switch (this.orderInfo.status) {
        case 'Completed':
        case 'Invalid':
        case 'Finished':
          return {
            class: 'color-gray',
          };
        case 'Effective':
          return {
            class: 'color-green',
          };
        case 'Controversy':
        case 'Negotiate':
        case 'Arbitration':
          return {
            class: 'color-red',
          };
        case 'Processing':
        case 'Arbitrated':
          return {
            class: 'color-main',
          };
        default:
          return {
            class: 'color-main',
          };
      }
    }
  },
  created() {
    this.getOrderDetail();
  },
  methods: {
    changeOrderInfo(orderInfo) {
      this.orderInfo.status = orderInfo.status
    },
    /**
     * @description 订单详情
     */
    getOrderDetail() {
      if (this.isOrderLoading) return;
      this.isOrderLoading = true;
      this.showLoading = true;
      orderDetail({
        orderNo: this.orderNo,
      })
        .then(({ data }) => {
          if (data) {
            clearTimeout(this.timer);
            this.orderInfo = data;
            this.showLoading = false;
            this.playerUserUuid = data.playerUserUuid;
            this.setSteps(data.orderRecordList);
            this.setIntervalTimer(data);
          }
          this.isOrderLoading = false;
          this.pageLoaded = true;
          this.isRefresh = false;
        })
        .catch((err) => {
          this.isOrderLoading = false;
          console.log(err);
          this.isRefresh = false;
        });
    },
    /**
     * @description 设置订单流程list
     * @param {Array} steps
     */
    setSteps(steps) {
      let records = [
        'Effective',
        'Processing',
        'PlayerConfirm',
        'Completed',
        'Finished',
      ];
      if (this.orderInfo.status === 'Controversy') {
          records = [
            'Effective',
            'Processing',
            'PlayerConfirm',
            'Controversy',
            'Completed',
            'Finished',
           ];
      }
      if (this.orderInfo.status === 'Negotiate') {
          records = [
            'Effective',
            'Processing',
            'PlayerConfirm',
            'Controversy',
            'Negotiate',
            'Completed',
            'Finished',
           ];
      }
      let currentIndex = records.indexOf(this.orderInfo.status);
      let hasPlayerConfirm = !!~steps.findIndex(
        (item) => item.afterOptionStatus === 'PlayerConfirm'
      );
      if (currentIndex > 2 && !hasPlayerConfirm) {
        records.splice(2, 1);
      }
      if (!steps) steps = [];

      if (this.orderInfo.status === 'Invalid') {
        if (this.orderInfo.refundType === 'FULL') {
          records = ['Effective', 'Processing', 'Controversy', 'alreadyBack'];
        } else {
          records = ['Effective', 'Invalid'];
        }
      }
      if (this.orderInfo.status === 'REFUND_SUCCESS') {
        let refoundStatus =
          this.orderInfo.refundType === 'FULL' ? 'REFUND_FULL' : 'REFUND_PART';
        records = ['Effective', 'Processing', refoundStatus];
      }
      this.steps = records.map((item, index) => {
        let newVal = { ...steps[index] } || { afterOptionStatus: item };
        newVal.label = item == 'Controversy' ? this.orderInfo.userNickname + this.stepsLabel[item] : this.stepsLabel[item];
        newVal.afterOptionStatus = item;
        return newVal;
      });
    },
    /**
     * @description 设置接单倒计时
     */
    setIntervalTimer(data) {
      let countDownHours = 0;
      let targetTime = 0;

      if (data.paymentTime && data.status === 'Effective') {
        countDownHours = 24;
        targetTime = data.paymentTime;
      } else if (data.updateTime && data.status === 'Controversy') {
        countDownHours = 48;
        targetTime = data.updateTime;
      }

      if (!countDownHours || !targetTime) return;

      let diff =
        countDownHours * 60 * 60 * 1000 - (new Date().getTime() - targetTime);

      if (diff <= 0) {
        data.status = countDownHours === 24 ? 'Invalid' : 'Negotiate';
        return;
      }

      let seconds = Math.floor((diff % (60 * 1000)) / 1000);
      let minutes = Math.floor((diff % (60 * 60 * 1000)) / (60 * 1000));
      let hour = Math.floor(diff / (60 * 60 * 1000));

      this.countDownText = `${hour > 9 ? hour : '0' + hour}:${
        minutes > 9 ? minutes : '0' + minutes
      }:${seconds > 9 ? seconds : '0' + seconds}`;

      this.timer = setTimeout(() => {
        this.setIntervalTimer(data);
      }, 1000);
    },
    /**
     * @description: 调起ordercard中调方法（历史迁移问题，待后续重构）
     */
    handleEvent(methodName, orderId) {
      this.$emit('closeOrderDialog');
      if (!~this.$route.path.indexOf('order')) {
        this.$refs['orderCardRef'][methodName](orderId);
      } else {
        this.$emit(methodName, orderId);
      }
    },
  },
};
</script>
<style lang="scss">
@media screen and (max-width: 559px) {
}
.order-wrap > .el-dialog__wrapper {
  .el-dialog {
    border-radius: 8px;
  }
  .el-dialog__body {
    padding: 20px 18px !important;
  }
  .el-dialog__header {
    padding: 18px;
    border-bottom: 1px solid #ececec;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 25px;
    color: #000000;
    .el-dialog__headerbtn {
      font-size: 20px;
      .el-dialog__close {
        font-weight: 800;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.b-order-detail-wrap {
  background: #fff;
}
.loading-line {
  height: 40px;
  margin: 30px auto 0;

  p {
    @include flex();
    height: 40px;
  }

  i {
    font-size: 1.6em;
  }
}
.order-info {
  border-radius: 30px;
  background: #fff;
  overflow: hidden;
  margin-top: 10px;
  box-shadow: 0 0 15px 0 rgba(178, 178, 178, 0.19);

  &.color-red {
    .header span:last-child {
      color: #fb0046;
    }
  }

  &.color-green {
    .header span:last-child {
      color: #2abe2f;
    }
  }

  &.color-gray {
    .header span:last-child,
    .footer div,
    .footer span {
      color: #999999;
    }
    color: #999999;
  }

  .header,
  .body {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 26px;
    padding: 0 30px;
  }

  .header {
    height: 90px;

    span {
      &:first-child {
        text-align: left;
      }

      &:last-child {
        flex-shrink: 0;
      }
    }
  }

  .body {
    height: 120px;
    border-top: 1px solid #e6e6e6;

    .buyer-info {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .buyer-img {
      width: 80px;
      height: 80px;
      margin-right: 20px;
    }

    .chat-icon,
    .chat-icon img {
      width: 54px;
      height: 48px;
    }
  }

  .footer {
    height: 100px;
    border-top: 1px solid #e6e6e6;
    padding: 0 30px;

    display: flex;
    justify-content: center;
    align-items: center;

    font-size: 26px;

    div {
      flex-grow: 1;
      width: 33%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #333333;
      font-weight: 500;

      &.skill-name {
        justify-content: flex-start;
      }

      &.skill-total {
        font-weight: 900;
        justify-content: flex-end;
      }
    }

    span {
      color: $color-yellow;
    }
  }
}

.note {
  width: 610px;
  height: 350px;
  margin-top: 30px;
  border-radius: 30px;
  box-shadow: 0 0 15px 0 rgba(178, 178, 178, 0.19);
  background: #fff;
}

.btns {
  display: flex;
  align-items: center;
  margin-top: 30px;

  button {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 88px;
    padding: 0 64px;
    border-radius: 60px;
    font-size: 28px;
    color: #333;
    line-height: 1;
    background: #f0f0f0;
    font-weight: 500;

    &.main-btn {
      @include button-yellow;
      border: none;
    }

    &:not(:last-child) {
      margin-right: 32px;
    }
  }
}

.record-line-top {
  color: #999;
  margin-top: 34px;
  margin-bottom: 16px;
  line-height: 40px;
}

.record-line-content {
  word-break: break-word;
  line-height: 34px;
}

.note {
  width: 610px;
  height: 350px;
  background: #fff;
  padding: 30px;
  font-size: 26px;
  color: #666;
  line-height: 36px;

  .content {
    margin-top: 1em;
  }

  .footer {
    margin-top: 1em;
    text-align: right;
  }

  span {
    color: $color-yellow;
    text-decoration: underline;
  }
}

.card-hide {
  height: 0;
  overflow: hidden;
}
.progress-container {
  margin-top: 20px;
}
.progress-title {
  margin-bottom: 6px;
  line-height: 27px;
  font-weight: 600;
  text-align: left;
}
.progress-step {
  margin-left: 11px;
}
.progress-content {
  font-size: 12px;
  color: #999999;
  font-weight: 500;
}
.progress-defalut {
  color: #999999;
}
</style>
